import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { selectApp, setSelectedFilterCategory } from "../../app/appSlice";

const FilterBadges = ({ data }) => {
  const dispatch = useDispatch();
  const { selectedFilterCategory, page, lastFocusedElement } = useSelector(selectApp);

  useEffect(() => {
    const currentPage = page.name;
    if (data && data.length > 0) {
      if(currentPage !== lastFocusedElement?.prevPage) {
        dispatch(setSelectedFilterCategory(data[0].filter));
      }
    }

  }, [dispatch, data, lastFocusedElement, page.name]);

  const handleBadgeClick = (event, category) => {
    event?.preventDefault();
    event?.stopPropagation();
    dispatch(setSelectedFilterCategory(category));
  };

  return (
    <div className="category-badges d-flex justify-content-center">
      {data.map((category, index) => (
        <button
          key={index}
          type="button"
          onClick={(event) => handleBadgeClick(event, category.filter)}
          onKeyDown={(event) => {
            if (event.key === "Enter" || event.keyCode === 13) {
              event.preventDefault();
              event.stopPropagation();
              handleBadgeClick(event, category.filter);
            }
          }}
          className={`focusable badge m-2 border-0 ${
            selectedFilterCategory === category.filter
              ? "bg-light text-dark active"
              : "bg-dark"
          }`}
        >
          {category.filter}
        </button>
      ))}
    </div>
  );
};

export default FilterBadges;
